import { render, staticRenderFns } from "./AccessMenu.vue?vue&type=template&id=0a78fffa&"
import script from "./AccessMenu.vue?vue&type=script&lang=js&"
export * from "./AccessMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports